import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Modal, Tooltip, OverlayTrigger } from 'react-bootstrap';
import { ModalStyled } from '../../../../theme/customizedStyleComponents';
import UserInfoDetails from './userInfoDetails';
import { trackRecentView } from '../../../../services/clinicPortalServices/recentViewService';

import RecordDetails from '../../../common/RecordDetails';
const panelStyles = { overlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.3)', zIndex: 1040 }, panel: { position: 'fixed', top: 0, right: 0, width: '420px', height: '100vh', background: '#fff', boxShadow: '-4px 0 20px rgba(0,0,0,0.15)', zIndex: 1041, display: 'flex', flexDirection: 'column', overflowY: 'auto' }, header: { padding: '16px 20px', borderBottom: '1px solid #e0e0e0', display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#f8f9fa' }, title: { margin: 0, fontSize: '16px', fontWeight: 600, color: '#333' }, body: { padding: '20px', flex: 1 }, section: { marginBottom: '20px' }, sectionTitle: { fontSize: '11px', fontWeight: 700, color: '#888', letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: '10px', paddingBottom: '6px', borderBottom: '1px solid #eee' }, dl: { display: 'grid', gridTemplateColumns: '150px 1fr', rowGap: '8px', margin: 0 }, dt: { fontSize: '13px', color: '#555', fontWeight: 600, paddingRight: '8px' }, dd: { fontSize: '13px', color: '#222', margin: 0 }, editBtn: { background: '#0066cc', color: '#fff', border: 'none', borderRadius: '4px', padding: '6px 14px', fontSize: '13px', cursor: 'pointer', marginRight: '8px' }, closeBtn: { background: 'transparent', border: 'none', fontSize: '18px', cursor: 'pointer', color: '#666' } };

export default class EditBtnCellRenderer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            showPanel: false,
            userInfoId: props.data._id,
            errors: []
        };
    }

    handleShow = () => {
        this.setState({ show: true });
        // Track recent view
        const userInfo = this.props.data;
        if (userInfo) {
            trackRecentView('user_info', userInfo._id, userInfo.name || 'User Info', '/clinic/userInfo');
        }
    };

    handleClose = () => {
        this.setState({ show: false });
    };

    renderPanel() {
        const d = this.props.data;
        return ReactDOM.createPortal(
            <>
                <div style={panelStyles.overlay} onClick={() => this.setState({ showPanel: false })} />
                <div style={panelStyles.panel}>
                    <div style={panelStyles.header}>
                        <h5 style={panelStyles.title}>User Info Details</h5>
                        <div>
                            <button style={panelStyles.editBtn} onClick={() => { this.setState({ showPanel: false }); this.handleShow(); }}><i className="fas fa-pen" style={{ marginRight: 5 }}></i>Edit</button>
                            <button style={panelStyles.closeBtn} onClick={() => this.setState({ showPanel: false })}><i className="fas fa-times"></i></button>
                        </div>
                    </div>
                    <div style={panelStyles.body}>
                        <div style={panelStyles.section}>
                            <div style={panelStyles.sectionTitle}>User Information</div>
                            <dl style={panelStyles.dl}>
                                <dt style={panelStyles.dt}>Name</dt><dd style={panelStyles.dd}>{d.name || '—'}</dd>
                                <dt style={panelStyles.dt}>Email</dt><dd style={panelStyles.dd}>{d.email || '—'}</dd>
                                <dt style={panelStyles.dt}>Role</dt><dd style={panelStyles.dd}>{d.role || '—'}</dd>
                                <dt style={panelStyles.dt}>Facility</dt><dd style={panelStyles.dd}>{(d.facility_id && d.facility_id.name) || d.facility_source || '—'}</dd>
                                <dt style={panelStyles.dt}>Status</dt><dd style={panelStyles.dd}>{d.status || '—'}</dd>
                            </dl>
                        </div>
                    
                        <RecordDetails data={d} exclude={['email', 'facility_id', 'facility_source', 'name', 'role', 'status', 'results', 'password', 'token', 'resetPasswordToken', 'refreshToken']} />
                    </div>
                </div>
            </>,
            document.body
        );
    }

    renderTooltipEdit = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Edit
        </Tooltip>
    );

    render() {
        return (
            <div>
                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={<Tooltip id="button-tooltip">View User Info</Tooltip>}>
                    <button onClick={() => this.setState({ showPanel: true })} className="edit-order-btn">
                        <i className="fas fa-eye"></i>
                    </button>
                </OverlayTrigger>
                {this.state.showPanel && this.renderPanel()}
                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={this.renderTooltipEdit}>
                    <button onClick={this.handleShow} className="edit-order-btn">
                        <i className="fas fa-pen"></i>
                    </button>
                </OverlayTrigger>
                <ModalStyled
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={this.state.show}
                    onHide={this.handleClose}
                    backdrop="static"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Update User Info</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <UserInfoDetails
                            userInfoId={this.state.userInfoId}
                            context={this.props.context}
                            handleClose={this.handleClose}
                        />
                    </Modal.Body>
                </ModalStyled>
            </div>
        );
    }
}
